<template>
	<!-- 所有考试信息 -->
	<div class="home" v-if="showExam">

		<!-- 顶部工具栏：搜索、添加、导出 -->
		<div class="search_line">
			<div class="first_search_line">
				<!-- 				<el-autocomplete v-if="userType=='admin'" class="auto_comp" clearable
					v-model="check_search_data.school_name" :fetch-suggestions="querySearch" :trigger-on-focus="false"
					size="mini" placeholder="学校" /> -->
				<el-input style="width: 200px;margin-right: 20px;" clearable v-model="check_search_data.course"
					:trigger-on-focus="false" size="mini" placeholder="课程名称" />
				<!-- <el-tooltip style="width: 200px;margin-right: 20px;" effect="dark" content="输入日期如: 5.5" -->
					<!-- placement="top-start"> -->
				<!-- </el-tooltip> -->
				<el-input style="width: 200px;margin-right: 20px;" clearable v-model="check_search_data.class_name"
					:trigger-on-focus="false" size="mini" placeholder="班级名称" />
				<el-date-picker style="width: 400px;margin-right: 20px;" v-model="check_search_data.range_time" type="daterange" range-separator="至" start-placeholder="开始日期"
					end-placeholder="结束日期" size="mini" value-format="yyyy-MM-dd">
				</el-date-picker>
			</div>
			<div class="second_search_line">
				<el-button class="search_bt" type="danger" icon="el-icon-search" size="mini" @click="getChecks()">
					搜索
				</el-button>
			</div>
		</div>

		<!-- 内容表格 -->
		<el-table :data="tableData" :header-cell-style="{background:'#409EFF',color:'white'}" size="mini">
			<el-table-column prop="course" label="课程名称" />
			<el-table-column prop="createTime" label="考勤时间" />
			<el-table-column prop="class_name" label="班级" />
			<el-table-column prop="grade" label="年级" />
			<el-table-column prop="should" label="应到" />
			<el-table-column prop="actual" label="实到"/>
			<el-table-column prop="ask" label="请假"/>
			<el-table-column prop="absence" label="旷课"/>

			<el-table-column prop="edit" label="查看" width="60">
				<template slot-scope="scope">
					<el-button @click="handleView(scope.row)" type="text" size="mini" class="edit_bt"><i
							class="el-icon-view"></i></el-button>
				</template>
			</el-table-column>

			<el-table-column prop="delete" label="删除" width="60"   v-if="userinfo.permit!='1'">
				<template slot-scope="scope">
					<el-button @click="handleDelete(scope.row)" type="text" size="mini" class="delete_bt"><i
							class="el-icon-delete"></i></el-button>
				</template>
			</el-table-column>

		</el-table>

		<div class="pagination">
			<el-pagination background layout="total, prev, pager, next" @current-change="handleCurrentChange"
				:total="total_num">
			</el-pagination>
		</div>


	</div>

	<!-- 该场考试分数 -->
	<div class="home" v-else="showExam">
		<!-- 顶部工具栏：搜索、添加、导出 -->
		<div class="search_line">
			<div class="first_search_line">
				<el-input style="width: 200px;margin-right: 20px;margin-left: 25px;" clearable
					v-model="check_student_search_data.sid" :trigger-on-focus="false" size="mini" placeholder="学号" />
				<el-input style="width: 200px;margin-right: 20px;" clearable v-model="check_student_search_data.student_name"
					:trigger-on-focus="false" size="mini" placeholder="姓名" />
				<el-select style="width: 200px;margin-right: 20px;" v-model="check_student_search_data.male" clearable
					placeholder="性别" size="mini">
					<el-option v-for="item in ['男','女']" :key="item" :label="item" :value="item">
					</el-option>
				</el-select>
				<el-select style="width: 200px;margin-right: 20px;" v-model="check_student_search_data.state" clearable
					placeholder="状态" size="mini">
					<el-option v-for="item in ['已到','请假','旷课']" :key="item" :label="item" :value="item">
					</el-option>
				</el-select>
			</div>
			<div class="second_search_line">
				<el-button class="search_bt" type="danger" icon="el-icon-d-arrow-left" size="mini" @click="back()">
					返回
				</el-button>
				<el-button class="search_bt" type="primary" icon="el-icon-search" size="mini" @click="getCheckStudent()">
					搜索
				</el-button>
				<el-button class="search_bt" type="success" icon="el-icon-download" size="mini" @click="exportCheck()">
					导出
				</el-button>
			</div>
		</div>

		<!-- 内容表格 -->
		<el-table :data="checkStudentData" :header-cell-style="{background:'#409EFF',color:'white'}" size="mini">
			<el-table-column prop="sid" label="学号" />
			<el-table-column prop="name" label="姓名" />
			<el-table-column prop="male" label="性别" />
			<el-table-column prop="state" label="状态" />
			<el-table-column prop="detail" label="详细" />
		</el-table>

<!-- 		<div class="pagination">
			<el-pagination background layout="total, prev, pager, next" @current-change="handleCurrentChange"
				:total="total_num">
			</el-pagination>
		</div> -->

	</div>





</template>

<script>
	export default {
		name: "Score",
		data() {
			return {
				showExam: true,
				check_id: '',
				userType: window.localStorage.getItem("userType"),
				userinfo:'',
				check_search_data: {
					course: '',
					create_time: '',
					class_name: '',
					range_time:'',
				},
				check_student_search_data: {
					sid: '',
					student_name: '',
					male: '',
					state:''
				},
				student: {
					name: '',
					total: '',
				},
				scores: [],
				major_options: ['田径', '体操', '足球', '篮球', '武术', '排球', '游泳'],
				tableData: [],
				checkStudentData: [],
				items: [],
				total_num: 0,
				dialogteacherAddVisible: false,
				showTip: false,
				result: '',
				dialogteacherEditVisible: false,
				dialogImportStudentVisible: false,
				dialogstudentScoreVisible: false,
				file_list: [],
			}
		},
		mounted() {
			this.getChecks();
		},
		methods: {
			getChecks(page, nums) {
				page = !page ? 1 : page
				nums = !nums ? 10 : nums
				const that = this
				var range_time = this.check_search_data.range_time
				if(!range_time){
					range_time = [null,null]
				}
				let data = {
					userType: that.userType,
					page: page,
					nums: nums,
					course: this.check_search_data.course,
					create_time: this.check_search_data.create_time,
					class_name: this.check_search_data.class_name,
					start_time: range_time[0],
					end_time: range_time[1],
				}
				// 获取信息
				this.$axios({
					method: 'post',
					url: '/jfapi/webgetChecks',
					data: that.qs.stringify(data),
				}).then(function(res) {
					that.tableData = res.data.records
					that.total_num = res.data.total
				});

				// 获取用户信息
				that.$axios({
					url: '/jfapi/userinfo/' + that.userType
				}).then(function(res) {
					that.userinfo = res.data
				})
			},
			querySearch(queryString, cb) {
				this.$axios({
					url: '/jfapi/getSchollHint?queryString=' + queryString,
				}).then(function(res) {
					cb(res.data)
				});
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getChecks(val)
			},
			import_dialog() {
				this.file_list = [];
				this.dialogImportStudentVisible = true;
			},
			down_student_templete() {
				window.location.href = "/jfapi/down_student_templete"
			},
			import_student() {
				this.$refs.upload.submit()
			},
			import_error() {
				this.$message({
					message: '上传失败，请检查格式是否与模板一致！',
					type: 'error'
				});

			},
			import_success() {
				this.$message({
					message: '上传成功！',
					type: 'success'
				});
				this.getStudentInfo();
				this.dialogImportStudentVisible = false;
			},
			clearList() {
				this.file_list = [];
			},
			handleView(row) {
				this.showExam = false
				this.check_id = row.id
				this.getCheckStudent()
			},
			handleDelete(row) {
				var r = confirm("删除后不可恢复，请谨慎操作！确定删除吗？");
				if (r == true) {
					const that = this
					this.$axios({
						url: '/jfapi/delChecks?id=' + row.id + '&userType=' + that.userType,
					}).then(function(res) {
						that.getChecks()
					});
				}
			},
			getCheckStudent() {
				let data = {
					userType: this.userType,
					id: this.check_id,
					sid: this.check_student_search_data.sid,
					student_name: this.check_student_search_data.student_name,
					male: this.check_student_search_data.male,
					state: this.check_student_search_data.state
				}
				var that = this
				this.$axios({
					method: 'post',
					url: '/jfapi/getCheckStudents',
					data: that.qs.stringify(data),
				}).then(function(res) {
					that.checkStudentData = res.data
				});
			},
			back() {
				this.showExam = true
			},
			handleViewStudent(row) {
				this.student.name = row.name
				this.student.total = row.total
				let data = {
					stu_id: row.stu_id,
					examId: this.check_id
				}
				var that = this
				// 获取学生各项分数
				this.$axios({
					method: 'post',
					url: '/jfapi/score/get_Scores',
					data: that.qs.stringify(data),
				}).then(function(res) {
					that.scores = res.data
					that.dialogstudentScoreVisible = true
				});
			},
			exportCheck(){
				window.location.href = '/jfapi/exportCheck?id=' + this.check_id + '&userType=' + this.userType
			}
		}
	};
</script>

<style lang="scss" scoped>
	.search_line {
		display: flex;
		width: 90%;
		flex-wrap: wrap;
		justify-content: space-between;
		padding-left: 10px;
		padding-right: 10px;
	}

	.first_search_line {
		width: 100%;
		display: flex;
		margin-left: 22px;
		justify-content: flex-start;
	}

	.second_search_line {
		width: 80%;
		display: flex;
		justify-content: flex-start;
		margin-left: 18px;
		margin-top: 10px;
	}

	.auto_comp {
		width: 250px;
	}

	.auto_comp .el-input {
		width: 80%;
	}

	input {
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}

	.search_bt {
		margin-left: 5px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}

	.export_bt {
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}

	.el-table {
		margin-top: 10px;
		font-size: small;
		width: 96%;
		margin-left: 2%;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) // box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
	}

	.edit_bt {
		color: #00ff7f;
	}

	.delete_bt {
		color: red;
	}

	.pagination {
		width: 90%;
		margin-left: 5%;
		margin-top: 10px;
		display: flex;
		justify-content: flex-end;
	}

	.input_title span {
		margin: 0;
		color: #959595;
		font-size: 10px;
	}

	.input_title {
		display: flex;
		justify-content: space-between;
		width: 80%;
		margin-left: 10%;
		margin-top: 10px;
	}

	.el-input__inner:focus {
		border-color: #00b27a;
	}

	.el-dialog__body {
		padding: 0;
	}

	.el-dialog {
		width: 40%;
		padding-top: 20px;
		padding-bottom: 20px;
	}

	.el-dialog .el-autocomplete {
		width: 100%;
	}

	font {
		color: #ff0000;
		margin-right: 10px;
	}

	.male_select {
		width: 100%;
		margin-left: 10%;
	}

	.el-dialog div .el-input {
		width: 80%;
	}

	.el-dialog div .el-select {
		width: 100%;
		margin-left: 10%;
	}
</style>
